var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import SkillRow from './SkillRow.vue';
import CreateSkillDialog from '@/components/create-skill-dialog/CreateSkillDialog';
import { SkillCategory } from '@/models/SkillCategory';
let SkillSetRow = class SkillSetRow extends Vue {
    constructor() {
        super(...arguments);
        this.editing = false;
        this.orginalName = '';
        this.isShowingSkillDialog = false;
        this.isConfirmingDelete = false;
    }
    // Class Methods
    openCreateSkillDialog() {
        this.isShowingSkillDialog = true;
    }
    confirmDeleteSkillSet() {
        this.isConfirmingDelete = true;
        this.isShowingSkillDialog = true;
    }
    onConfirmDeleteSkillSet() {
        this.isShowingSkillDialog = false;
        this.isConfirmingDelete = false;
        this.deleteSkillSet();
    }
    // Emits
    onSkillDeleted() {
        this.$emit('onSkillDeleted');
    }
    onSkillUpdated() {
        this.$emit('onSkillUpdated');
    }
    onSkillCreated() {
        this.isShowingSkillDialog = false;
        this.$emit('onSkillCreated');
    }
    // Asyncs
    async deleteSkillSet() {
        try {
            await this.skillSet.delete();
            this.$emit('onSkillUpdated');
        }
        catch (error) {
            //
        }
    }
    async updateSkillSet() {
        try {
            await this.skillSet
                .update({ name: this.skillSet.name });
            this.$emit('onSkillUpdated');
            this.editing = false;
        }
        catch (error) {
            //
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof SkillCategory !== "undefined" && SkillCategory) === "function" ? _a : Object)
], SkillSetRow.prototype, "skillSet", void 0);
SkillSetRow = __decorate([
    Component({
        components: {
            SkillRow,
            CreateSkillDialog,
        },
    })
], SkillSetRow);
export default SkillSetRow;
